/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { isPresent } from '@ember/utils';
import Component from '@glimmer/component';
import AudienceCredentialModel from 'cio/models/audience-credential';
import IntegrationModel from 'cio/models/integration';
import AnalyticsService from 'cio/services/analytics';
import AuthService from 'cio/services/auth';
import { AdNetworkType } from 'cio/utils/ad-audiences';
import { StaticIntegration } from 'cio/utils/integrations/static-integrations';
import DS from 'ember-data';

interface AudiencesSyncIntegrationComponentArgs {
  integration: StaticIntegration | IntegrationModel;
  credentials: AudienceCredentialModel[];
}

export default class AudiencesSyncIntegrationComponent extends Component<AudiencesSyncIntegrationComponentArgs> {
  @service auth!: AuthService;
  @service store!: DS.Store;
  @service analytics!: AnalyticsService;

  @computed('args.{credentials.@each.type,integration.id}')
  get credential() {
    return this.args.credentials.findBy('type', this.args.integration.id as AdNetworkType);
  }

  @action
  onClick() {
    let { name, type } = this.args.integration;
    this.analytics.track('integration', 'clicked', {
      name,
      category: 'Advertising',
      enabled: isPresent(this.credential),
      type,
      from: 'In-App',
    });
  }
}
